import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ResizeObserver from "resize-observer-polyfill";

import { TABLE_HEADER_HEIGHT } from "../constants";

import { getBottomHeight, getBottomState } from "../../../ducks/layout/selectors";

export const useTableHeight = (): number => {
  const bottomState: string = useSelector(getBottomState);
  const bottomHeight: number = useSelector(getBottomHeight);
  const [windowHeight, setWindowHeight] = useState(document.body.offsetHeight);
  const tableHeight: number =
    bottomState !== "fullscreen" ? bottomHeight - TABLE_HEADER_HEIGHT : windowHeight - TABLE_HEADER_HEIGHT;

  useEffect(() => {
    if (bottomState !== "fullscreen") {
      return;
    }

    const ro = new ResizeObserver(entries => {
      for (const entry of entries) {
        setWindowHeight(entry.contentRect.height);
      }
    });

    ro.observe(document.body);

    return () => {
      ro.unobserve(document.body);
    };
  });

  return tableHeight;
};
